(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-price"] && !Shopify.designMode) return;
  try {
    (function () {
  function htCents(cents) {
    return Math.round(cents * 100 / 120);
  }

  function refreshPrice(root, variant) {
    if (!variant || !root) return;
    var price = root.querySelector('#ProductPrice');
    if (price) {
      var ht = price.querySelector('.bigmat-price-ht');
      if (!ht) {
        ht = document.createElement('small');
        ht.className = 'bigmat-price-ht';
        price.appendChild(ht);
      }
      ht.textContent = theme.Currency.formatMoney(htCents(Number(variant.price)), theme.strings.moneyFormat) + ' HT';
      if (!price.querySelector('.bigmat-price-ttc-label')) {
        var ttc = document.createElement('small');
        ttc.className = 'bigmat-price-ttc-label';
        ttc.textContent = 'TTC';
        price.insertBefore(ttc, ht);
      }
    }

    var compare = root.querySelector('#ComparePrice');
    if (compare && variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
      var compareHt = compare.querySelector('.bigmat-price-ht');
      if (!compareHt) {
        compareHt = document.createElement('small');
        compareHt.className = 'bigmat-price-ht';
        compare.appendChild(compareHt);
      }
      compareHt.textContent = theme.Currency.formatMoney(htCents(Number(variant.compare_at_price)), theme.strings.moneyFormat) + ' HT';
      if (!compare.querySelector('.bigmat-price-ttc-label')) {
        var compareTtc = document.createElement('small');
        compareTtc.className = 'bigmat-price-ttc-label';
        compareTtc.textContent = 'TTC';
        compare.insertBefore(compareTtc, compareHt);
      }
    }
  }

  if (window.jQuery) {
    jQuery(document).on('variantPriceChange.bigmatTtcHt', '[data-section-type="product-template"]', function (event) {
      var root = this;
      window.setTimeout(function () {
        refreshPrice(root, event.variant);
      }, 0);
    });
  }
}());
  } catch(e) { console.error(e); }
})();

})();
